import React from 'react'

export default class Header extends React.Component {
  render() {
    return (
      <div className='table-header'>{this.props.children}</div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Table/Header.js